import React from 'react'
import { Box } from '@mui/material'

interface DefaultChatIconProps {
  color?: string
  backgroundColor?: string
  width?: number
  height?: number
  alt?: string
}

const DefaultChatIcon: React.FC<DefaultChatIconProps> = ({
  color = '#FFF',
  backgroundColor = '#000',
  width = 48,
  height = 48,
  alt = 'Chat icon',
}) => (
  <Box
    aria-label={alt}
    sx={{
      display: 'flex',
      borderRadius: '100%',
      border: `${height < 30 ? 1 : 2}px solid #E0E0E0`,
      height: height,
      width: width,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: backgroundColor,
    }}
  >
    <svg
      id='chatIcon'
      style={{ width: width / 2, height: height / 2, fill: color }}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
    >
      <path
        fill={color}
        d='M12 2C6.477 2 2 6.477 2 12c0 1.82.487 3.53 1.338 5L2 22l5-1.338C8.47 21.513 10.18 22 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm0 18c-1.657 0-3.224-.393-4.615-1.088L4.5 19.5l.588-2.885C4.393 15.224 4 13.657 4 12c0-4.418 3.582-8 8-8s8 3.582 8 8-3.582 8-8 8z'
      ></path>
    </svg>
  </Box>
)

export default DefaultChatIcon
